import { Box, CircularProgress, Stack } from "@mui/material";
import { LoadingSpinner, Text } from "@src/appV2/redesign/system/ui-components";

import { ProfileImage } from "../../WorkWithFriends/components/ProfileImage";

interface ProfileImageSectionProps {
  firstName: string;
  lastName: string;
  profileImageUrl?: string;
  isLoadingProfileImage: boolean;
  isUploading: boolean;
}

export function ProfileImageSection(props: ProfileImageSectionProps) {
  const { firstName, lastName, profileImageUrl, isLoadingProfileImage, isUploading } = props;

  return (
    <Stack spacing={4} alignItems="center">
      {/* Profile Image */}
      <Box
        sx={{
          position: "relative",
          opacity: isUploading ? 0.6 : 1,
        }}
      >
        {isLoadingProfileImage ? (
          <Box
            sx={{
              width: 120,
              height: 120,
              borderRadius: "50%",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              backgroundColor: (theme) => theme.palette.background.secondary,
            }}
          >
            <LoadingSpinner size="medium" />
          </Box>
        ) : (
          <ProfileImage
            size="large"
            firstName={firstName}
            lastName={lastName}
            src={profileImageUrl}
          />
        )}

        {/* Loading Overlay */}
        {isUploading && (
          <Box
            sx={{
              position: "absolute",
              top: 0,
              left: 0,
              right: 0,
              bottom: 0,
              borderRadius: "50%",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              backgroundColor: "rgba(0, 0, 0, 0.7)",
            }}
          >
            <CircularProgress
              size={40}
              sx={{
                color: "common.white",
              }}
            />
          </Box>
        )}
      </Box>

      <Stack spacing={2} alignItems="center">
        <Text variant="body1" sx={{ textAlign: "center", maxWidth: 400 }}>
          {isUploading
            ? "Uploading your photo..."
            : "Facilities use your photo to confirm your identity."}
        </Text>
        <Text
          variant="body2"
          sx={(theme) => ({
            textAlign: "center",
            maxWidth: 400,
            color: theme.palette.text.secondary,
          })}
        >
          Current photos with no filter are encouraged.
        </Text>
      </Stack>
    </Stack>
  );
}
